import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";


export const useGenerateConsultationReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (consultationId: string) => {
      return api.post(`report/generate/${consultationId}`);
    },
    onSuccess: (res: any, variables) => {
      queryClient.invalidateQueries(
        consultationQKeys.singleConsultation(variables)
      );
    },

    onError: (res: any) => {
      console.error("[From Regenerate Report]", res);
    },
  });
};
